<template>
  <div class="fb-account account-box">
    <a-row type="flex" class="account-title">
      <a-col flex="auto">
        <span class="account-name">【BM账户管理】-{{nowRow.name}}</span>
        <span class="account-time">上次更新时间：{{synTime}}</span>
        <a-button type="link" class="syn-log-btn">同步日志</a-button>
        <a-tooltip class="syn-help">
          <template slot="title">
            <span style="font-size: 12px">系统每小时同步一次数据，点击【同步日志】按钮可以查看你的BM账号同步信息</span>
          </template>
          <icon-font type="icon-Question-Circle-Fill"/>
        </a-tooltip>
      </a-col>
      <a-col flex="270px">
        <a-input-search class="input-search" placeholder="请输入广告帐户名称或者ID" @search="search" />
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col flex="270px" v-if="showBm">
        <div>
          <a-button class="syn-mcc-btn" @click="synClick" :disabled="synLoading"><icon-font type="icon-Reload" :class="synLoading?'active':''"/>同步BM</a-button>
          <div>
            <a-radio-group @change="bmChange" v-model="bmSelets">
              <div v-for="v in bmList" :key="v.fbBusinessesId" class="bm-item">
                <a-row justify="space-between" type="flex" class="bm-info">
                  <div class="bm-name">{{v.bmName}}</div>
                  <a-radio :value="v.fbBusinessesId"></a-radio>
                </a-row>
                <a-row justify="space-between" type="flex" class="bm-info">
                  <span>{{v.fbBusinessesId}}</span>
                  <span>2019-11-06 19:40:34</span>
                </a-row>
              </div>
            </a-radio-group>
          </div>
        </div>
      </a-col>
      <a-col flex="auto" class="account-table-box">
        <a-table
          :columns="showBm?columns.slice(1):columns"
          :row-key="(record, index) => index"
          :data-source="data"
          :pagination="pagination"
          size="small"
          :loading="loading"
          @change="handleTableChange"
          class="account-table"
        >
          <template slot="handle" slot-scope="text, record">
            <a-popconfirm
              title="是否确认删除？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="deleteClick(record)"
            >
              <a-button type="link">删除</a-button>
            </a-popconfirm>
          </template>
          <template slot="index" slot-scope="text, record, index">
            <span>{{index + 1}}</span>
          </template>
        </a-table>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { pageBmOfUser, fbPageAccountOfBm, getBmSynTime, fbSynBM, getFBUsers } from "@/api/mediadata"

const columns = [
  {
    title: 'BM',
		dataIndex: 'bmName',
		width: 150,
		align: 'center',
  },
	{
		title: '账号ID',
		dataIndex: 'fbAccountId',
		width: 150,
		align: 'center',
	},
	{
		title: '账号名称',
		dataIndex: 'name',
		align: 'center',
		width: 200,
	},
	{
		title: '币种',
		dataIndex: 'currency',
		align: 'center',
		width: 80,
	},
	{
		title: '时区',
		dataIndex: 'timeZoneOffset',
		align: 'center',
		width: 100,
		// scopedSlots: { customRender: 'objective_type' },
	}
]
export default {
	name: 'MediaData',
	data() {
		return {
			loading: false,
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10
			},
			data: [],
      bmList: [],
      bmSelets: null,
			columns,
      synLoading: false,
      synTime: '',
      showBm: true
		}
	},
  props: ['nowRow'],
  methods: {
    init() {
      this.showBm = true
      this.getBmList()
    },
    // 同步账号
    synClick() {
      this.synLoading = true
      fbSynBM({
        userId: this.nowRow.userId,
      }).then((res) => {
        this.$message.success('同步成功！')
        this.getBmList()
        this.getSynTime()
      }).finally(() => this.synLoading = false)
    },
    getSynTime() {
      getBmSynTime({
        userId: this.nowRow.userId,
      }).then((res) => {
        this.synTime = res.data
      })
    },
    bmChange(e) {
      this.getList()
    },
    getBmList(searchKeyWord) {
      pageBmOfUser({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        userId: this.nowRow.userId,
        searchKeyWord
      }).then((res) => {
        this.bmList = res.data.recordList || []
      })
    },
    search(value) {
      this.pagination.current = 1
      this.getList(value)
    },
    getList(searchKeyWord) {
      this.loading = true
      fbPageAccountOfBm({
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        bmOrMcc: this.bmSelets,
        userId: this.nowRow.userId,
        searchKeyWord
      }).then((res) => {
        this.showBm = !searchKeyWord
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    handleTableChange(pagination, filters, sorter) {
			console.log(pagination);
			const pager = { ...this.pagination };
			pager.current = pagination.current;
			this.pagination = pager;
			this.getList()
		},
  },
  mounted() {
  }
}
</script>
<style lang="less" scoped>
.fb-account {
  .account-title {
    margin-bottom: 16px;
  }
  .syn-mcc-btn {
    margin-bottom: 7px;
  }
  .bm-item {
    padding: 2px 16px;
    width: 270px;
    box-sizing: border-box;
  }
  .bm-name {
    color: #2D3446;
    font-size: 14px;
    line-height: 22px;
  }
  .bm-info {
    line-height: 20px;
    font-size: 12px;
    color: #677392;
  }
  .account-table-box {
    overflow: hidden;
  }
  .account-table {
    width: 100%;
  }
}
</style>